import { useEffect } from "react";
import { LicenseManager } from '@ag-grid-enterprise/core';
import { AG_GRID_LICENSE_KEY } from "utils/constants";

export const useAgGridEnterpriseLicense = () => {
  useEffect(() => {
    LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
  }, []);
};
